export default __webpack_public_path__ + "static/media/Essex_Color.8d8bbc9f.png";